<!-- This is the root view of the app - everything loads via router -->
<app-mainmenu></app-mainmenu>
<router-outlet></router-outlet>
